/*
 * jQuery CharCount Plugin v1.1
 *
 * Copyright (c) 2012-2016 Sergey Leonov
 *
 * Date: 2016-02-03 14:23:28
 */

(function($) {

  $.fn.charCount = function(options) {

    // default configuration properties
    var defaults = {
      'limit': 150,
      'css': 'counter',
      'counterElement': 'span',
      'counterText': '[x]/[limit] characters'
    };

    var opts = $.extend({}, defaults, options);

    function calculate(field) {
      var count = field.value.length,
          available = '',
          limit = $(field).data("text-limit") || opts['limit'];

      if (count >= limit) {
        field.value = field.value.substring(0, limit);
        available = opts['counterText'].replace('[x]', 0);
      } else {
        available = opts['counterText'].replace('[x]', limit - count);
      }
      available = available.replace('[limit]', limit);
      $(field).next().html(available);
    }

    this.each(function() {
      var el = $(this),
        clazz = opts['css'] + ' ';
        clazz += (typeof(el.attr('name')) != 'undefined' && el.attr('name').length != 0) ? el.attr('name') : 'd'+(new Date()).getTime();
        clazz += '-'+opts['css'];

      el.after('<'+ opts['counterElement'] + ' class="' + clazz + '">'+ opts['counterText'] +'</'+ opts['counterElement'] +'>');
      calculate(this);
      el.keyup(function(){calculate(this);});
      el.change(function(){calculate(this);});
    });
    return this;
  };

})(jQuery);
